import { useLanguage } from '@/context/LanguageContext';
import { Check } from 'lucide-react';

export default function AboutSection() {
  const { t } = useLanguage();
  const includes = t('about.includes') || [];
  const stats = t('stats') || [];

  return (
    <section id="about" className="py-24 md:py-32 lg:py-40 bg-[#050505]" data-testid="about-section">
      <div className="px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto">
        {/* Header */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 mb-20 md:mb-28">
          <div className="space-y-6">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-[#C8B598]">
              {t('about.overline')}
            </p>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#F5F5F0] leading-tight">
              {t('about.title')}
            </h2>
          </div>
          <div className="flex items-end">
            <p className="text-base font-light leading-relaxed text-[#9CA3AF]">
              {t('about.description')}
            </p>
          </div>
        </div>

        {/* Includes list */}
        <div className="mb-20 md:mb-28">
          <h3 className="text-xl sm:text-2xl font-light font-heading text-[#F5F5F0] mb-8">
            {t('about.includesTitle')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Array.isArray(includes) && includes.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-3 p-4 bg-[#0f1115] border border-white/5 hover:border-[#C8B598]/20 transition-colors"
                data-testid={`about-include-${i}`}
              >
                <div className="mt-0.5 w-5 h-5 flex-shrink-0 flex items-center justify-center bg-[#C8B598]/10 border border-[#C8B598]/30">
                  <Check className="w-3 h-3 text-[#C8B598]" />
                </div>
                <span className="text-sm font-light text-[#F5F5F0]">{item}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/5 border border-white/5" data-testid="stats-grid">
          {Array.isArray(stats) && stats.map((stat, i) => (
            <div
              key={i}
              className="bg-[#0f1115] p-6 lg:p-10 flex flex-col items-center justify-center text-center group hover:bg-[#0f1115]/80 transition-colors"
              data-testid={`stat-${i}`}
            >
              <span className="font-heading text-3xl md:text-4xl lg:text-5xl font-light text-[#C8B598] group-hover:scale-105 transition-transform">
                {stat.value}
              </span>
              <span className="mt-2 text-xs uppercase tracking-[0.15em] text-[#9CA3AF]">
                {stat.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
